// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Voltage Divider Calculator Specific Styles */
.formula {
  font-family: 'Times New Roman', Times, serif;
  font-size: 1.1rem;
  margin-bottom: 0.5rem;
  padding: 0.5rem;
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 4px;
}

[data-bs-theme='dark'] .formula {
  background-color: rgba(255, 255, 255, 0.05);
}

.formula sub {
  font-size: 65%;
  margin-left: 1px;
  margin-right: 1px;
}

.calculated-field {
  border: 3px solid #ffc107 !important;  /* Bootstrap warning yellow */
  background-color: rgba(255, 193, 7, 0.05) !important;
  box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.25);
  font-weight: 500 !important;
  color: #ffc107 !important;
}

/* Highlighted result values */
.text-primary.fw-bold {
  font-size: 1.2rem;
}

/* Voltage Divider specific diagram elements */
.resistor-label {
  font-family: monospace;
  font-size: 12px;
  fill: white;
  text-anchor: middle;
}

.voltage-divider-label {
  font-family: monospace;
  font-size: 14px;
  fill: white;
}

.wire {
  stroke: white;
  stroke-width: 2;
}

.resistor-zigzag {
  stroke: white;
  stroke-width: 2;
  fill: none;
}

.ground-symbol {
  stroke: white;
  stroke-width: 2;
}

.junction-dot {
  fill: white;
  stroke: none;
}

.diode-symbol {
  stroke: white;
  stroke-width: 2;
}

/* Blue highlight for the calculate dropdown */
.calculate-mode-dropdown {
  border: 2px solid #0d6efd;
  box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.25);
  background-color: rgba(13, 110, 253, 0.05);
  font-weight: 500;
}

.small-text {
  font-size: 10px;
  fill: #aaaaaa;
} `, "",{"version":3,"sources":["webpack://./src/components/VoltageDividerCalculatorCore.css"],"names":[],"mappings":"AAAA,+CAA+C;AAC/C;EACE,4CAA4C;EAC5C,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;EACf,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oCAAoC,GAAG,6BAA6B;EACpE,oDAAoD;EACpD,gDAAgD;EAChD,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA,8BAA8B;AAC9B;EACE,iBAAiB;AACnB;;AAEA,8CAA8C;AAC9C;EACE,sBAAsB;EACtB,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA,8CAA8C;AAC9C;EACE,yBAAyB;EACzB,iDAAiD;EACjD,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;AACf","sourcesContent":["/* Voltage Divider Calculator Specific Styles */\n.formula {\n  font-family: 'Times New Roman', Times, serif;\n  font-size: 1.1rem;\n  margin-bottom: 0.5rem;\n  padding: 0.5rem;\n  background-color: rgba(0, 0, 0, 0.05);\n  border-radius: 4px;\n}\n\n[data-bs-theme='dark'] .formula {\n  background-color: rgba(255, 255, 255, 0.05);\n}\n\n.formula sub {\n  font-size: 65%;\n  margin-left: 1px;\n  margin-right: 1px;\n}\n\n.calculated-field {\n  border: 3px solid #ffc107 !important;  /* Bootstrap warning yellow */\n  background-color: rgba(255, 193, 7, 0.05) !important;\n  box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.25);\n  font-weight: 500 !important;\n  color: #ffc107 !important;\n}\n\n/* Highlighted result values */\n.text-primary.fw-bold {\n  font-size: 1.2rem;\n}\n\n/* Voltage Divider specific diagram elements */\n.resistor-label {\n  font-family: monospace;\n  font-size: 12px;\n  fill: white;\n  text-anchor: middle;\n}\n\n.voltage-divider-label {\n  font-family: monospace;\n  font-size: 14px;\n  fill: white;\n}\n\n.wire {\n  stroke: white;\n  stroke-width: 2;\n}\n\n.resistor-zigzag {\n  stroke: white;\n  stroke-width: 2;\n  fill: none;\n}\n\n.ground-symbol {\n  stroke: white;\n  stroke-width: 2;\n}\n\n.junction-dot {\n  fill: white;\n  stroke: none;\n}\n\n.diode-symbol {\n  stroke: white;\n  stroke-width: 2;\n}\n\n/* Blue highlight for the calculate dropdown */\n.calculate-mode-dropdown {\n  border: 2px solid #0d6efd;\n  box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.25);\n  background-color: rgba(13, 110, 253, 0.05);\n  font-weight: 500;\n}\n\n.small-text {\n  font-size: 10px;\n  fill: #aaaaaa;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
